'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var SCROLL_LOAD_THRESHOLD = 10;

var InfiniteScroll = function (_React$Component) {
  _inherits(InfiniteScroll, _React$Component);

  function InfiniteScroll(props) {
    _classCallCheck(this, InfiniteScroll);

    var _this = _possibleConstructorReturn(this, (InfiniteScroll.__proto__ || Object.getPrototypeOf(InfiniteScroll)).call(this, props));

    _this.setScrollContainerRef = _this.setScrollContainerRef.bind(_this);
    _this.onScrollToTop = _this.onScrollToTop.bind(_this);
    _this.scrollContainerToBottom = _this.scrollContainerToBottom.bind(_this);
    return _this;
  }

  _createClass(InfiniteScroll, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var preventScrollOnMount = this.props.preventScrollOnMount;

      if (!preventScrollOnMount) {
        var heightDifference = this.props.newestAtBottom && !this.props.scrollToHeader ? this.scrollContainer.scrollHeight - this.scrollContainer.clientHeight : 0;
        this.scrollContainerToBottom();
        this.scrollContainer.scrollTop = heightDifference;
        this.scrollTop = heightDifference;
      }
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      this.updateScrollTop();
    }
  }, {
    key: 'getNewScrollTop',
    value: function getNewScrollTop() {
      var _scrollContainer = this.scrollContainer,
          scrollTop = _scrollContainer.scrollTop,
          scrollHeight = _scrollContainer.scrollHeight;


      if (!this.props.newestAtBottom || this.props.preventScrollOnMount) {
        return scrollTop;
      }

      var updatedScrollTop = scrollHeight - (this.scrollHeight || 0);

      return scrollTop + updatedScrollTop;
    }
  }, {
    key: 'getScrollTopFromBottom',
    value: function getScrollTopFromBottom() {
      return this.scrollContainer.scrollHeight + 4;
    }
  }, {
    key: 'scrollContainerToBottom',
    value: function scrollContainerToBottom() {
      this.scrollContainer.scrollTop = this.getScrollTopFromBottom();
    }
  }, {
    key: 'setScrollContainerRef',
    value: function setScrollContainerRef(element) {
      this.scrollContainer = element ? (0, _reactDom.findDOMNode)(element) : null;
    }
  }, {
    key: 'updateScrollTop',
    value: function updateScrollTop() {
      var newScrollTop = this.getNewScrollTop();
      this.updateScrollTopWithValue(newScrollTop);
    }
  }, {
    key: 'updateScrollTopWithValue',
    value: function updateScrollTopWithValue(newScrollTop) {
      this.scrollContainer.scrollTop = newScrollTop;
      this.scrollTop = this.scrollContainer.scrollTop;
      this.scrollHeight = this.scrollContainer.scrollHeight;
    }
  }, {
    key: 'isPassedThreshold',
    value: function isPassedThreshold() {
      var newestAtBottom = this.props.newestAtBottom;
      var _scrollContainer2 = this.scrollContainer,
          scrollHeight = _scrollContainer2.scrollHeight,
          clientHeight = _scrollContainer2.clientHeight;


      return newestAtBottom ? this.scrollContainer.scrollTop <= SCROLL_LOAD_THRESHOLD : this.scrollContainer.scrollTop >= scrollHeight - clientHeight - SCROLL_LOAD_THRESHOLD;
    }
  }, {
    key: 'onScrollToTop',
    value: function onScrollToTop() {
      if (this.scrollContainer.scrollTop !== this.scrollTop) {
        if (this.isPassedThreshold()) {
          this.props.fetchMore();
        }
        // the dom is ahead of the state
        this.updateScrollTop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          children = _props.children;

      return _react2.default.createElement(
        'div',
        {
          className: className,
          style: { flexGrow: 1 },
          ref: this.setScrollContainerRef,
          onScroll: this.onScrollToTop
        },
        children
      );
    }
  }]);

  return InfiniteScroll;
}(_react2.default.Component);

InfiniteScroll.propTypes = {
  children: _react.PropTypes.node,
  className: _react.PropTypes.string,
  fetchMore: _react.PropTypes.func.isRequired,
  newestAtBottom: _react.PropTypes.bool.isRequired,
  preventScrollOnMount: _react.PropTypes.bool.isRequired,
  scrollToHeader: _react.PropTypes.bool
};

InfiniteScroll.defaultProps = {
  newestAtBottom: true,
  preventScrollOnMount: false
};

exports.default = InfiniteScroll;
module.exports = exports['default'];